import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=635aa8fe&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandingLogoByMedel: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Branding/LogoByMedel.vue').default,BrandingIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Branding/Icon.vue').default,MenuMain: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/Main.vue').default,MenuMeta: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/Meta.vue').default})
